import React from "react";
import styled from "styled-components";

export default styled.input`
    width: 663px;
    height: 53px;
    padding: 10px;
    margin-right: 25px;
    border: 1px solid #979797;
    float: left;
    color: #979797;
    font-size: 20px;
`;